import { Form } from "@/shared/form/Form";
import { FormFieldType } from "@/shared/form/FormDefinition";

/**
 * `content.imprint` of the Bauwerksbuch report snapshot.
 *
 * The imprint page is rendered by the block the existing report already uses,
 * so the field names match it; the labels follow the Bauwerksbuch standard-text
 * catalog. Every field is seeded from the catalog and therefore optional.
 */
export interface BauwerksbuchImprintFormData {
  editorialTeam: string;
  editorialDeadline: string;
  impressumClient: string;
  authors: string;
  allAuthors: string;
  advice: string;
}

export class BauwerksbuchImprintForm extends Form<BauwerksbuchImprintFormData> {
  protected definition = {
    editorialTeam: {
      label: "Redaktion",
      type: FormFieldType.Text,
      required: false
    },
    editorialDeadline: {
      label: "Redaktionsschluss",
      type: FormFieldType.Date,
      required: false
    },
    impressumClient: {
      label: "Auftraggeber Detail",
      type: FormFieldType.Text,
      required: false
    },
    authors: {
      label: "Autoren",
      type: FormFieldType.Text,
      required: false
    },
    allAuthors: {
      label: "Alle Autoren",
      type: FormFieldType.Text,
      required: false
    },
    advice: {
      label: "Hinweis",
      type: FormFieldType.Text,
      required: false
    }
  };
}
